import {Button, Icon} from '@ezcater/tapas';
import {type IconDefinition} from '@fortawesome/pro-solid-svg-icons';
import {twMerge} from 'tailwind-merge';

type SuggestedSearchChipProps = {
  icon?: IconDefinition;
  id: string;
  isActive?: boolean;
  label: string;
  onClick?: () => void;
};

const SuggestedSearchChip: React.FC<SuggestedSearchChipProps> = ({
  icon,
  id,
  isActive = false,
  label,
  onClick,
}) => {
  return (
    <Button
      aria-selected={isActive}
      className={twMerge(
        'gap-x-1.5 whitespace-nowrap rounded-full border-peppercorn-200 font-medium hover:border-transparent hover:bg-green-50',
        isActive && 'border-transparent bg-green-50 ring-2 ring-green-300',
      )}
      id={id}
      onClick={onClick}
      onMouseDown={event => event.preventDefault()}
      role="option"
      size="small"
      tabIndex={-1}
      type="button"
      variant="outlined"
    >
      {icon && <Icon aria-hidden className="text-xs" icon={icon} />}
      {label}
    </Button>
  );
};

export default SuggestedSearchChip;
